<div class="main-wrapper">
  <form   [formGroup]="form"
    (ngSubmit)="onSubmit($event.submitter.id)"
    class="default-form"
    >
    <div class="form-fields">


      <div class="improve_epic_form_container d-flex flex-column flex-lg-row mb-0 pb-0">
        <div class="box-left flex-grow-1 px-0">

          <mat-form-field appearance="fill" class="default-full-width mb-0">
            <mat-label>Epic Description</mat-label>
            <textarea
              matInput
              placeholder="{{
                'anms.organization.form.placeholder.name' | translate
              }}"
              formControlName="epicDescription"
            ></textarea>
            <mat-hint>Hint</mat-hint>
            @if (form.get('epicDescription').invalid) {
              <mat-error>
                {{ 'anms.organization.form.placeholder.name' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <button
            class="arrow-btn"
            (click)="moveTextToLeft(form.get('improvedEpicDescription').value)"
            >
            <fa-icon [icon]="['fas', 'arrow-up']" size="2x"></fa-icon>
          </button>
        </div>

        <div class="box-right flex-grow-1 px-0">
          @if (descriptions$ | async; as descriptions) {
            @for (description of descriptions.slice(1); track description) {
              <div>
                <p>{{description}}
                </p>
              </div>
              <mat-divider></mat-divider>
            }
          }
          <mat-form-field
            appearance="fill"
            class="default-full-width mb-0 mt-3 mt-lg-0"
            >
            <mat-label>Generated AI Epic Description</mat-label>
            <textarea matInput formControlName="improvedEpicDescription">
            </textarea>
            <mat-hint>This epic description was generated by AI using the full context of the epic.</mat-hint>
            @if (form.get('improvedEpicDescription').invalid) {
              <mat-error>
                {{ 'anms.organization.form.placeholder.name' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="default-full-width mb-0 mt-3 mt-lg-0"
            >
            <mat-label>Add more context</mat-label>
            <textarea matInput formControlName="context">
            </textarea>
            <mat-hint>Hint</mat-hint>
            @if (form.get('context').invalid) {
              <mat-error>
                {{ 'anms.improve-epic.form.placeholder.context' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>



    </div>
    <div class="form-actions">
      <div class="action-col secondary">
        <button
          mat-raised-button
          color="secondary"
          class="btn-save"
          (click)="copyContentToParent()"
          [disabled]="!form.valid"
          >
          Save Description to Epic
        </button>
      </div>
      <div class="action-col primary">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="btn-load"
          [disabled]="!form.valid"
          id="load"
          >
          Use AI
        </button>
      </div>

    </div>

  </form>
</div>
